module.exports = __webpack_public_path__ + "static/img/setting_question.5483442c.png";